export default __webpack_public_path__ + "static/media/paid.4ca2ea93.png";